<template>
  <div>
    <Skeleton width="40%" height="1rem" class="mb-2"></Skeleton>
    <Skeleton width="100%" height="3rem"></Skeleton>
  </div>
</template>

<script setup>
import Skeleton from "primevue/skeleton";
</script>
